var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.background,attrs:{"id":"SectionLuminor"}},[_c('div',{staticClass:"cta"},[_c('a',{staticClass:"Btn",attrs:{"href":"https://luminor.lt/nogrid","target":"_blank","title":_vm.$t('cta')}},[_vm._v(" "+_vm._s(_vm.$t('cta'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }